import React, { useState, useEffect } from "react";

// import PropTypes from "prop-types";
import { Link, useSearchParams } from "react-router-dom";
import styled from "styled-components";

// source
import ArrowBack from "../assets/icons/arrow_back.svg";
import { useTranslation } from "react-i18next";
import ImageSlider from "../components/ImageSlider";

import shuttleInfoAImg01 from "../assets/img/shuttleInfoA01.jpg";
import shuttleInfoAImg02 from "../assets/img/shuttleInfoA02.jpg";
import shuttleInfoBImg01 from "../assets/img/shuttleInfoB01.jpg";
import shuttleInfoBImg02 from "../assets/img/shuttleInfoB02.jpg";
import shuttleInfoCImg01 from "../assets/img/shuttleInfoC01.jpg";
import shuttleInfoCImg02 from "../assets/img/shuttleInfoC02.jpg";
import shuttleInfoDImg01 from "../assets/img/shuttleInfoD01.jpg";
import shuttleInfoDImg02 from "../assets/img/shuttleInfoD02.jpg";

const imagesA = [shuttleInfoAImg01, shuttleInfoAImg02];
const imagesB = [shuttleInfoBImg01, shuttleInfoBImg02];
const imagesC = [shuttleInfoCImg01, shuttleInfoCImg02];
const imagesD = [shuttleInfoDImg01, shuttleInfoDImg02];

const TableHeader = styled.th`
  padding: 6px 12px;
  text-align: center;
  border-top: 1px solid #393939;
  border-bottom: 1px solid #393939;
  width: 22%;
  font-weight: normal;
  font-size: 15px;
  color: #a2a2a2;
`;

const TableHeaderHighlight = styled.th`
  padding: 6px 12px;
  text-align: center;
  border-top: 1px solid #393939;
  border-bottom: 1px solid #393939;
  width: 22%;
  font-weight: 500;
  font-size: 15px;
  color: #066aeb;
`;

const TableData = styled.td`
  padding: 6px 12px;
  text-align: center;
  border-bottom: 1px solid #c9c9c9;
  font-size: 15px;
  color: #a2a2a2;
`;

const LastTableData = styled.td`
  padding: 5px 12px;
  text-align: center;
  border-bottom: 1px solid #393939;
  font-size: 15px;
  color: #a2a2a2;
`;

const BottomInfoText1 = styled.div`
  margin-top: 22px;
  font-size: 14px;
  color: #515151;
  line-height: 1.5;
`;
const BottomInfoText2 = styled.div`
  margin-top: 10px;
  font-size: 13px;
  color: #6d6d6d;
  line-height: 1.5;
  margin-bottom: 40px;
`;

const ConditionalWrapper = ({ condition, wrapper, children }) => {
  return condition ? wrapper(children) : children;
};

const ShuttleInfo = () => {
  const { t, i18n } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const region = searchParams.get("region");
  const back = searchParams.has("back") ? searchParams.get("back") : "path";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div
        style={{
          position: "fixed",
          display: "flex",

          zIndex: 1,
          top: 16,
          left: 16,
          inset: "auato 0 0 auto",
        }}
      >
        <Link to={back === "path" ? "/path?transport=shuttle" : "/"}>
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              padding: 0,
            }}
          >
            <img src={ArrowBack} alt="" />
          </button>
        </Link>
      </div>

      <div
        style={{
          height: "100%",
          backgroundColor: "white",
          padding: "26px",
          color: "#282D4B",
        }}
      >
        <div
          style={{
            padding: "38px 0 0 0",
          }}
        >
          <ImageSlider
            style={{
              display: "block",
              width: "100%",
              height: "80px",
              borderRadius: "8px",
            }}
            images={
              region === "A"
                ? imagesA
                : region === "B"
                ? imagesB
                : region === "C"
                ? imagesC
                : imagesD
            }
          ></ImageSlider>
          <div
            style={{
              paddingTop: "20px",
              color: "#066AEB",
              fontWeight: "600",
              fontSize: "22px",
              paddingLeft: "6px",
              paddingRight: "6px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                display: "flex",
              }}
            >
              <span>{t(`shuttleInfo.titleType${region}`)}</span>
              <span
                style={{
                  color: "#fff",
                  backgroundColor: "#066AEB",
                  padding: "4px 9px",
                  fontSize: "18px",
                  borderRadius: "8px",
                  marginLeft: "auto",
                  height: "23px",
                }}
              >
                {region}
              </span>
            </div>
          </div>
          <div
            style={{
              paddingTop: "0px",
              color: "#515151",
              paddingLeft: "8px",
              fontSize: "14px",
            }}
          >
            {t("shuttleInfo.kakaoFreeShuttle")}
          </div>
        </div>
        <div
          style={{
            padding: "6px",
            display: "block",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "30px",
          }}
        >
          <table
            style={{
              borderCollapse: "collapse",
              backgroundColor: "white",
            }}
          >
            <thead>
              <tr
                style={{
                  borderBottomWidth: "1px",
                  borderBottomColor: "black",
                  borderBottomStyle: "solid",
                  width: "12%",
                }}
              >
                <TableHeader></TableHeader>
                <ConditionalWrapper
                  condition={region === "A"}
                  wrapper={(children) => (
                    <TableHeaderHighlight>A</TableHeaderHighlight>
                  )}
                >
                  <ConditionalWrapper
                    condition={region !== "A"}
                    wrapper={(children) => <TableHeader>A</TableHeader>}
                  ></ConditionalWrapper>
                </ConditionalWrapper>
                <ConditionalWrapper
                  condition={region === "B"}
                  wrapper={(children) => (
                    <TableHeaderHighlight>B</TableHeaderHighlight>
                  )}
                >
                  <ConditionalWrapper
                    condition={region !== "B"}
                    wrapper={(children) => <TableHeader>B</TableHeader>}
                  ></ConditionalWrapper>
                </ConditionalWrapper>
                <ConditionalWrapper
                  condition={region === "C"}
                  wrapper={(children) => (
                    <TableHeaderHighlight>C</TableHeaderHighlight>
                  )}
                >
                  <ConditionalWrapper
                    condition={region !== "C"}
                    wrapper={(children) => <TableHeader>C</TableHeader>}
                  ></ConditionalWrapper>
                </ConditionalWrapper>
                <ConditionalWrapper
                  condition={region === "D"}
                  wrapper={(children) => (
                    <TableHeaderHighlight>D</TableHeaderHighlight>
                  )}
                >
                  <ConditionalWrapper
                    condition={region !== "D"}
                    wrapper={(children) => <TableHeader>D</TableHeader>}
                  ></ConditionalWrapper>
                </ConditionalWrapper>
              </tr>
            </thead>
            <tbody>
              <tr>
                <TableData>1</TableData>
                {region === "A" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    10:00
                  </TableData>
                ) : (
                  <TableData>10:00</TableData>
                )}

                {region === "B" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    10:25
                  </TableData>
                ) : (
                  <TableData>10:25</TableData>
                )}
                {region === "C" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    10:35
                  </TableData>
                ) : (
                  <TableData>10:35</TableData>
                )}
                {region === "D" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    11:05
                  </TableData>
                ) : (
                  <TableData>11:05</TableData>
                )}
              </tr>
              <tr>
                <TableData>2</TableData>
                {region === "A" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    11:20
                  </TableData>
                ) : (
                  <TableData>11:20</TableData>
                )}

                {region === "B" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    11:45
                  </TableData>
                ) : (
                  <TableData>11:45</TableData>
                )}
                {region === "C" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    11:55
                  </TableData>
                ) : (
                  <TableData>11:55</TableData>
                )}
                {region === "D" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    12:25
                  </TableData>
                ) : (
                  <TableData>12:25</TableData>
                )}
              </tr>
              <tr>
                <TableData>3</TableData>
                {region === "A" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    12:40
                  </TableData>
                ) : (
                  <TableData>12:40</TableData>
                )}

                {region === "B" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    13:05
                  </TableData>
                ) : (
                  <TableData>13:05</TableData>
                )}
                {region === "C" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    13:15
                  </TableData>
                ) : (
                  <TableData>13:15</TableData>
                )}
                {region === "D" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    13:45
                  </TableData>
                ) : (
                  <TableData>13:45</TableData>
                )}
              </tr>
              <tr>
                <TableData>4</TableData>
                {region === "A" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    14:00
                  </TableData>
                ) : (
                  <TableData>14:00</TableData>
                )}

                {region === "B" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    14:25
                  </TableData>
                ) : (
                  <TableData>14:25</TableData>
                )}
                {region === "C" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    14:35
                  </TableData>
                ) : (
                  <TableData>14:35</TableData>
                )}
                {region === "D" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    15:05
                  </TableData>
                ) : (
                  <TableData>15:05</TableData>
                )}
              </tr>
              <tr>
                <TableData>5</TableData>
                {region === "A" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    15:20
                  </TableData>
                ) : (
                  <TableData>15:20</TableData>
                )}

                {region === "B" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    15:45
                  </TableData>
                ) : (
                  <TableData>15:45</TableData>
                )}
                {region === "C" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    15:55
                  </TableData>
                ) : (
                  <TableData>15:55</TableData>
                )}
                {region === "D" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    16:25
                  </TableData>
                ) : (
                  <TableData>16:25</TableData>
                )}
              </tr>
              <tr>
                <TableData>6</TableData>
                {region === "A" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    16:40
                  </TableData>
                ) : (
                  <TableData>16:40</TableData>
                )}

                {region === "B" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    17:05
                  </TableData>
                ) : (
                  <TableData>17:05</TableData>
                )}
                {region === "C" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    17:15
                  </TableData>
                ) : (
                  <TableData>17:15</TableData>
                )}
                {region === "D" ? (
                  <TableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    17:45
                  </TableData>
                ) : (
                  <TableData>17:45</TableData>
                )}
              </tr>
              <tr>
                <LastTableData>7</LastTableData>
                {region === "A" ? (
                  <LastTableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    18:00
                  </LastTableData>
                ) : (
                  <LastTableData>18:00</LastTableData>
                )}

                {region === "B" ? (
                  <LastTableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    18:30
                  </LastTableData>
                ) : (
                  <LastTableData>18:30</LastTableData>
                )}
                {region === "C" ? (
                  <LastTableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    18:35
                  </LastTableData>
                ) : (
                  <LastTableData>18:35</LastTableData>
                )}
                {region === "D" ? (
                  <LastTableData style={{ color: "#066aeb", fontWeight: 600 }}>
                    19:05
                  </LastTableData>
                ) : (
                  <LastTableData>19:05</LastTableData>
                )}
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <BottomInfoText1>
            <div>{t("shuttleInfo.BottomInfoText1_1")}</div>
            <div>{t("shuttleInfo.BottomInfoText1_2")}</div>
            <div>{t("shuttleInfo.BottomInfoText1_3")}</div>
          </BottomInfoText1>
          <BottomInfoText2>
            <div>{t("shuttleInfo.BottomInfoText2_1")}</div>
            <div>{t("shuttleInfo.BottomInfoText2_2")}</div>
          </BottomInfoText2>
        </div>
      </div>
    </div>
  );
};

export default ShuttleInfo;
